import { useEffect } from "react";
import { useLocation, BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import "./App.css";
import { initGA4, initMetaPixel, trackPageView } from "./lib/analytics";

// Pages
import HomePage from "./pages/HomePage";
import CollectionsPage from "./pages/CollectionsPage";
import CategoryDetailPage from "./pages/CategoryDetailPage";
import SelfCustomPage from "./pages/SelfCustomPage";
import HowItWorksPage from "./pages/HowItWorksPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import SizeGuidePage from "./pages/SizeGuidePage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsConditionsPage from "./pages/TermsConditionsPage";
import RefundPolicyPage from "./pages/RefundPolicyPage";
import ShopPage from "./pages/ShopPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import AdminPage from "./pages/AdminPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageView(pathname);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    // ── Analytics Init ──
    // Replace these with your actual IDs when ready:
    // initGA4('G-XXXXXXXXXX');       // Google Analytics 4
    // initMetaPixel('XXXXXXXXXXXXXXX'); // Meta Pixel
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/collections" element={<CollectionsPage />} />
          <Route path="/collections/self-custom" element={<SelfCustomPage />} />
          <Route path="/collections/:categoryId" element={<CategoryDetailPage />} />
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/size-guide" element={<SizeGuidePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-conditions" element={<TermsConditionsPage />} />
          <Route path="/refund-policy" element={<RefundPolicyPage />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/shop/:productId" element={<ProductDetailPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
